/**
 * @file loader.component.tsx
 * @description Компонент обертка для работы с @consta/uikit/Loader, который растягивается на всю доступную область.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

import { Loader as ConstaLoader } from '@consta/uikit/Loader';
import cn from 'classnames';

export const Loader = ({ className = '', ...props }) => {
    return (
        <div className={cn('w-full h-full flex items-center justify-center', className)}>
            <ConstaLoader {...props} color="brand" className="animate-fade" />
        </div>
    );
};
